import { Component, Input } from '@angular/core';
import { ModalService } from '../modal.service';
import { AbstractModal } from '../AbstractModal';

@Component({
  selector: 'ls-message-modal',
  templateUrl: 'message-modal.component.html'
})
export class MessageModalComponent extends AbstractModal {
  @Input()
  public data: any;

  constructor(private modal: ModalService) {
    super();
  }

  public close(message: string): void {
    this.modal.close(message);
  }
}
